import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "absolute left-1 top-1 text-xs"
};
const _hoisted_2 = {
  class: "flex flex-col text-center"
};
const _hoisted_3 = {
  class: "text-2xl font-bold"
};
const _hoisted_4 = {
  class: "text-sm"
};
export default /*#__PURE__*/_defineComponent({
  __name: 'CalendarDay',
  props: {
    date: null,
    markedDate: null,
    currentDate: null
  },
  setup(__props) {
    const props = __props;
    const classes = computed(() => {
      let isSameMonth = props.date.isSame(props.currentDate, 'month');
      let isSameDay = props.markedDate.isSame(props.date, 'date');
      return {
        'bg-sky-50 text-sky-600': isSameMonth && !isSameDay,
        'bg-slate-50 text-slate-400': !isSameMonth && !isSameDay,
        'bg-sky-600 text-sky-50': isSameDay
      };
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["flex-center m-0.5 first:ml-0 last:mr-0 rounded p-1 w-full font-bold h-20 relative", _unref(classes)])
      }, [__props.date.isSame(__props.date.startOf('week'), 'day') ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.date.week()), 1)) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "default", {}, () => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$date(__props.date, 'D')), 1), _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$date(__props.date, 'ddd')), 1)])])], 2);
    };
  }
});